/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import isObject from 'lodash/isObject';

// TODO Unit testy.
/**
 * Továrna na správce zpoždění.
 * @implements {Destroyable}
 */
class ViewerDelayerFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ViewerDelayer>} ViewerDelayer Konstruktor pro správce zpoždění.
   * @param {Object} [opts={}] Nepovinné parametry.
   * @param {number} [opts.delay] Zpoždění, které se aplikuje při detekovaném zacyklení.
   * @param {number} [opts.limit] Počet selhání v řadě, který se považuje za zacyklení.
   * @returns {ViewerDelayerFactory} Nová instance.
   */
  constructor(ViewerDelayer, { delay, limit } = {}) {
    if (!isObject(ViewerDelayer)) {
      throw new TypeError(
        `Invalid viewer delayer constructor ${ViewerDelayer}.`
      );
    }
    if (!isNil(delay) && !isNumber(delay)) {
      throw new TypeError(`Invalid delay ${delay}.`);
    }
    if (!isNil(limit) && !isNumber(limit)) {
      throw new TypeError(`Invalid limit ${limit}.`);
    }
    this.ViewerDelayer = ViewerDelayer;
    this.delay = delay;
    this.limit = limit;
  }

  /**
   * Vytvoří nového správce zpoždění.
   * @returns {ViewerDelayer} Vytvořený správce zpoždění.
   */
  create() {
    return new this.ViewerDelayer({ delay: this.delay, limit: this.limit });
  }
}

export default ViewerDelayerFactory;
